import {
    type GetCompanyForAdminResponseType,
    type GetCompanyForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const GetCompanyForAdmin = async (params: GetCompanyForAdminRequestType): Promise<GetCompanyForAdminResponseType> => {
    return await request<GetCompanyForAdminResponseType>(`/company/getCompanyForAdmin?companyID=${params.companyID}`, {
        method: "GET"
    });
};

export default GetCompanyForAdmin;
